import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import logo from './admin/admin_assets/img/logo.svg';
import AdminBrandAuditComponent from '../Components/AdminDashboard/Adminebook/AdminBrandAuditComponent';
import './QuickBrandLeadsPage.css';

const QuickBrandLeadsPage = () => (
  <div className="quick-brand-leads-shell">
    <aside className="quick-brand-leads-brand" aria-label="Brew Your Brand">
      <a href="/quick-brand-leads" aria-label="Quick Brand Leads">
        <img src={logo} alt="Brew Your Brand" />
      </a>
    </aside>

    <main className="quick-brand-leads-content">
      <AdminBrandAuditComponent />
    </main>
  </div>
);

export default QuickBrandLeadsPage;
